import src from "IMAGE";
export default { src, width: 80, height: 80, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
